import { render } from "./Employee.vue?vue&type=template&id=117c17d9&scoped=true&ts=true&lang=html"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"

import "./Employee.vue?vue&type=style&index=0&id=117c17d9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117c17d9"]])

export default __exports__